import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import SearchField from "shared/components/SearchField";
import { BORDER, COLOR_GREY_4 } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledContainer = styled(Box)`
  ${flex({ jc: "center" })};
  flex-wrap: wrap;
  border-bottom: ${BORDER(1, COLOR_GREY_4)};
  width: 100%;
  gap: 1rem;
  padding-bottom: 1rem;
`;

export const StyledSearchField = styled(SearchField)`
  width: calc(100% - 2rem);
`;

export const StyledFiltersContainer = styled(Box)`
  ${flex({ jc: "flex-start" })};
  flex-wrap: wrap;
  padding: 0 1rem;
  gap: 6px;
`;
